import { useContext } from 'react';
import { UserContext } from '../context';
import _ from 'lodash';

const withCurrentHost = (url) => {
  if (!url || typeof window === 'undefined') return `${url}`;
  const host = window.location.hostname;  
  if (host === 'localhost' || host === '127.0.0.1') return `${url}`;
  return `${url}`.replace(/\/\/(localhost|127\.0\.0\.1)(?=[:/]|$)/, `//${host}`);
};

export const toDevReachableUrl = (url) => {
  if (typeof url !== 'string' || typeof window === 'undefined') return url;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return url;
  const match = url.match(/^https?:\/\/(?:localhost|127\.0\.0\.1):9100(\/.*)$/);
  return match ? `${window.location.origin}/__minio${match[1]}` : url;
};

export const BaseURL = withCurrentHost(process.env.REACT_APP_URL);
export const EMPortal = withCurrentHost(process.env.REACT_APP_EMPLOYEE_PORTAL_URL);
export const ReportAPI = withCurrentHost(process.env.REACT_APP_REPORT_PORTAL_URL);
export const StaticBaseURL = withCurrentHost(process.env.REACT_APP_APP_STATIC_URL);
export const CBSupportEnv = `${process.env.REACT_APP_CBSupport}`;
export const DefaultAvatar = StaticBaseURL + 'default_avatar.png';
export const DefaultHumanAvatar = StaticBaseURL + 'default_avatar-img.png';
export const PMS = withCurrentHost(process.env.REACT_APP_PMS_URL);
export const PRE_BOARDING_STATUS = 1;
export const ON_BOARDING_STATUS = 2;

export const SHORT_ANSWER = 'SHORT_ANSWER';
export const RADIO_CHOICES = 'RADIO_CHOICES';
export const SCORE_TYPE = 'NUMERIC';

export const ACTION_EVENT = {
  SHOW: 'SHOW',
  DOWNLOAD: 'DOWNLOAD',
};

export const PayrollType = [
  { id: 'Monthly', name: 'Monthly' },
  { id: 'Hourly', name: 'Hourly' },
];
export const EMP_BOARDING_STATUS = {
  PENDING: 1,
  COMPLETED: 2,
  SIGNED: 3,
  TASK_ASSIGNED: 4,
  DRAFT: 5,
  INVITED: 6,
  REVOKED: 7,
  REJECTED: 8,
  ASSIGN_TASK: 9,
};

export const EMP_ONBOARDING_DOCUMENT_TYPE = {
  NDA: 1,
  MEDICAL: 2,
};

export const EVALUATION_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
};

export const RESPONSE = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export const EXPORT_TYPE = {
  ACCRUAL_REPORT: 'accrual_report ',
  ACCRUAL_LEAVE_DETAILS: 'leave_accrual_details',
  GRATUITY_REPRORT: 'gratuity_report',
  LOCALIZATION_REPORT: 'localization_report',
  DOCUMENT_REPORT: 'document_report',
  LEAVE_BALANCE_REPORT: 'leave_balance_report',
  OFFBOARDING_REPORT: 'offboarding_report',
  LEAVE_REQUEST_REPORT: 'leave_request_report',
  LEAVE_REQUEST_MONTHLY_REPORT: 'leave_request_monthly_report',
  LEAVE_FORECAST_REPORT: 'leave_forecast_report',
  EMPLOYEE_DATA_REPORT: 'employee_data_report',
};

export const EXPORT_WAITING_MESSAGE = 'Export under processing...';

export const FILE_EXTENSION_CSV = 'csv';
export const FILE_EXTENSION_XLS = 'xls';
export const FILE_EXTENSION_XLSX = 'xlsx';
export const FILE_EXTENSION_PDF = 'pdf';
export const FILE_EXTENSION_SIF = 'sif';

export const EXPORT_FILE = 'exports';

// Reports whose export actually produces a real .xlsx file on the backend (export_to_xls_real() in
// Helper.php) -- scoped list for downloadExcelFile()'s filename-extension fix, see src/common/file/download.js.
export const XLSX_REPORT_TYPES = [
  'localization_report',
  'document_report',
  'leave_balance_report',
  'offboarding_report',
  'attendance_daily_log',
  'leave_request_report',
  'leave_request_monthly_report',
  'leave_forecast_report',
  'employee_data_report',
];

export const daysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const LOGS_FILE = '/logs/';

export const timeShiftLegends = [
  {
    label: 'Normal time shift',
    color: '#8c2b81',
    backgroundColor: '#f5ecf4',
  },
  {
    label: 'Week Off',
    color: '#f15858',
    backgroundColor: '#fef2f2',
  },
  {
    label: 'Flexible time shift',
    color: '#41ce75',
    backgroundColor: '#dcfce7',
  },
  {
    label: 'No time shift',
    color: '#9ca3af',
    backgroundColor: '#f3f4f6',
  },
  {
    label: 'Overnight',
    color: '#FAD02C',
    backgroundColor: '#666666',
  },
  {
    label: 'On Leave',
    color: '#2196F3',
    backgroundColor: '#2196F31A',
  },
  {
    label: 'Holiday',
    color: '#9ca3af',
    backgroundColor: '#f3f4f6',
  },
];

export const Links = [
  {
    name: 'Leave',
    event: 'leave',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 1,
  },
  {
    name: 'Leave Advance',
    event: 'leave advance',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 2,
  },
  {
    name: 'Leave Encashment',
    event: 'leave encashment',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 3,
  },
  {
    name: 'Promotions',
    event: 'promotions',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 4,
  },
  {
    name: 'Award',
    event: 'award',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 5,
  },
  // { name: "Training" },
  {
    name: 'Transfer',
    event: 'transfer',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 6,
  },
  {
    name: 'Resignation',
    event: 'resignation',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 7,
  },
  {
    name: 'Termination',
    event: 'termination',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 8,
  },
  {
    name: 'Warning',
    event: 'warning',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 9,
  },
  {
    name: 'Complaint',
    event: 'complaint',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 10,
  },
  {
    name: 'Employee Ticket',
    event: 'employee ticket',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 11,
  },
  {
    name: 'Claims',
    event: 'claims',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 12,
  },
  {
    name: 'Overtime',
    event: 'overtime',
    navigate: '/company/PayrollAdmin',
    status: 0,
    tab: 3,
  },
  {
    name: 'Payroll Settlement',
    event: '',
    navigate: '/company/PayrollSettlement',
    status: 0,
    tab: 1,
  },
  {
    name: 'Off-Cycle',
    event: 'offcycle',
    navigate: '/company/PayrollAdmin',
    status: 0,
    tab: 1,
  },
  {
    name: 'Recurring Payment',
    event: 'recurring payment',
    navigate: '/company/PayrollAdmin',
    status: 0,
    tab: 2,
  },
  {
    name: 'Salary Adjustment',
    event: 'salary adjustment',
    navigate: '/company/PayrollAdmin',
    status: 0,
    tab: 4,
  },
  {
    name: 'Set Salary',
    event: 'set salary',
    navigate: '/company/PayrollAdmin',
    status: 0,
    tab: 5,
  },
  //{ name: "Government Tax" },
  { name: 'FnF', event: 'fnf', navigate: '/company/FnF', status: 0, tab: 1 },
  {
    name: 'Letter Request',
    event: 'letter request',
    navigate: '/company/letter-generator',
    status: 0,
    tab: 1,
  },
  {
    name: 'Comp Off',
    event: 'comp off',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 15,
  },
  {
    name: 'Swap Shift',
    event: 'swap shift',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 13,
  },
  {
    name: 'Attendance Exception',
    event: 'attendance exception',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 14,
  },
  {
    name: 'Leave Rejoin',
    event: 'leave rejoin',
    navigate: '/company/HRAdmin',
    status: 0,
    tab: 15,
  },
];

export const MainMenuItems = (isFavCondition) => {
  const { userInfo, activeBU, activeUserRole, updateAssignedLicenseModules } =
    useContext(UserContext);
  let isFav;
  if (isFavCondition) {
    isFav = (url, title) => {
      if (userInfo.currentRole) {
        const fav = _.find(userInfo.currentRole.user_preferences, function (p) {
          return (
            p.preference_name === 'FAV_SCREEN' &&
            p.company_id === userInfo.currentRole.company_id
          );
        });
        const fav_screen_access = _.map(
          userInfo?.access_control,
          function (access_cont) {
            const roleScreenAccess = _.find(
              access_cont?.acl,
              function (access) {
                return access?.screen_name === title;
              },
            );
            return roleScreenAccess;
          },
        ).filter((item) => item !== undefined && item !== null);
        if (fav) {
          if (fav.value === url && fav_screen_access.length > 0) return true;
          else {
            return false;
          }
        } else {
          return false;
        }
      }
    };
  } else {
    isFav = () => {};
  }

  let mainmenu = [
    {
      icon: null,
      title: 'Main',
      link: null,
    },
    {
      icon: <i className="las la-chart-pie" style={{ fontSize: '1.2em' }}></i>,
      title: 'Dashboard',
      link: '/company/dashboard',
      header: 'Main',
      is_fav: isFav('/company/dashboard', 'Dashboard'),
    },
    // {
    //   icon: <i className="las la-tachometer-alt" style={{ fontSize: "1.2em" }}></i>,
    //   title: 'HR Admin Dashboard',
    //   link: '/company/hrAdminDashboard',
    //   header: 'Main',
    //   is_fav: isFav('/company/hrAdminDashboard', 'HR Admin Dashboard'),
    // },
    {
      icon: <i className="las la-user-cog" style={{ fontSize: '1.2em' }}></i>,
      title: 'HR Admin',
      link: '/company/HRAdmin',
      header: 'Main',
      is_fav: isFav('/company/HRAdmin', 'HR Admin'),
    },
    {
      icon: <i className="las la-user" style={{ fontSize: '1.2em' }}></i>,
      title: 'Employee Data',
      link: '/company/EmployeeData',
      is_fav: isFav('/company/EmployeeData', 'Employee Data'),
      header: 'Main',
    },
    {
      icon: <i className="las la-user-friends" style={{ fontSize: '1.2em' }}></i>,
      title: 'Dependents',
      link: '/company/Dependents',
      is_fav: isFav('/company/Dependents', 'Dependents'),
      header: 'Main',
    },
    {
      icon: <i className="las la-id-badge" style={{ fontSize: '1.2em' }}></i>,
      title: 'Hire Employee',
      link: '/company/HireEmployee',
      is_fav: isFav('/company/EmployeeData', 'hire-employee'),
      header: 'Main',
    },
    {
      icon: <i className="las la-shield-alt" style={{ fontSize: '1.2em' }}></i>,
      title: 'Attendance',
      mainMenu: '/company/Attendance/AttendanceList',
      is_fav: isFav('/company/EmployeeData', 'Attendance'),
      subMenu: [
        {
          icon: <i className="las la-circle" style={{ fontSize: '0.5em' }}></i>,
          title: 'Attendance List',
          link: '/company/Attendance/AttendanceList',
        },
        {
          icon: <i className="las la-circle" style={{ fontSize: '0.5em' }}></i>,
          title: 'Week Off',
          link: '/company/Attendance/WeekOff',
        },
        {
          icon: <i className="las la-circle" style={{ fontSize: '0.5em' }}></i>,
          title: 'Time Shift',
          link: '/company/Attendance/time-shift',
        },
        {
          icon: <i className="las la-circle" style={{ fontSize: '0.5em' }}></i>,
          title: 'Shift & Schedule',
          link: '/company/Attendance/shift-schedule',
        },
        {
          icon: <i className="las la-circle" style={{ fontSize: '0.5em' }}></i>,
          title: 'Biometric Logs',
          link: '/company/Attendance/BiometricLogs',
        },
        {
          icon: <i className="las la-circle" style={{ fontSize: '0.5em' }}></i>,
          title: 'Face Setup',
          link: '/company/Attendance/FaceSetup',
        },
        /*  {
          icon: <i className="las la-circle" style={{ fontSize: '0.5em' }}></i>,
          title: 'Holidays',
          link: '/company/Attendance/Holidays',
        },
        {
          icon: <i className="las la-circle" style={{ fontSize: '0.5em' }}></i>,
          title: 'geofencing',
          link: '/company/Attendance/GeofencingLocation',
        }, */
      ],

      header: 'Main',
    },
    {
      icon: (
        <i className="las la-calendar-check" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Leave Allotment',
      link: '/company/Attendance/leave-allotment',
      is_fav: isFav('/company/Attendance/leave-allotment', 'Leave Allotment'),
      header: 'Main',
    },
    {
      icon: (
        <i className="las la-balance-scale" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Leave Reconciliation',
      link: '/company/Attendance/leave-reconciliation',
      is_fav: isFav(
        '/company/Attendance/leave-reconciliation',
        'Leave Reconciliation',
      ),
      header: 'Main',
    },
    {
      icon: (
        <i className="las la-umbrella-beach" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Holidays',
      link: '/company/Attendance/Holidays',
      is_fav: isFav('/company/Attendance/Holidays', 'Holidays'),
      header: 'Main',
    },
    {
      icon: (
        <i className="las la-map-marked-alt" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Geofencing',
      link: '/company/Attendance/GeofencingLocation',
      is_fav: isFav('/company/Attendance/GeofencingLocation', 'Geofencing'),
      header: 'Main',
    },
    {
      icon: <i className="las la-mobile-alt" style={{ fontSize: '1.2em' }}></i>,
      title: 'ESS Controller',
      link: '/company/ESSController',
      is_fav: isFav('/company/ESSController', 'ESS Controller'),
      header: 'Main',
    },
    {
      icon: (
        <i
          className="las la-bullhorn"
          color="#8F95B2"
          style={{ fontSize: '1.2em' }}
        ></i>
      ),
      title: 'Announcement',
      link: '/company/Announcement',
      is_fav: isFav('/company/Announcement', 'Announcement'),

      header: 'Main',
    },
    {
      icon: (
        <i
          className="lab la-wpforms"
          color="#8F95B2"
          style={{ fontSize: '1.2em' }}
        ></i>
      ),
      title: 'Suggestion',
      link: '/company/Suggestion',
      is_fav: isFav('/company/Suggestion', 'Suggestion'),

      header: 'Main',
    },
    // {
    //   icon: (
    //     <i
    //       className="las la-tasks"
    //       color="#8F95B2"
    //       style={{ fontSize: '1.2em' }}
    //     ></i>
    //   ),
    //   title: 'To-Do Task',
    //   link: '/company/ToDoTasks',
    //   is_fav: isFav('/company/ToDoTasks', 'To-Do Task'),

    //   header: 'Main',
    // },
    {
      icon: <i className="las la-bullseye" style={{ fontSize: '1.2em' }}></i>,
      title: 'Action Required',
      link: '/company/action-required',
      is_fav: isFav('/company/action-required', 'Action Required'),

      header: 'Main',
    },

    {
      icon: null,
      title: 'Admin Support',
      link: null,
      // header: "Main",
    },
    {
      icon: <i className="las la-pen-alt" style={{ fontSize: '1.2em' }}></i>,
      title: 'Assets',
      link: '/company/Assets',
      header: 'Admin Support',
      is_fav: isFav('/company/Assets', 'Assets'),
    },
    {
      icon: <i className="las la-briefcase" style={{ fontSize: '1.2em' }}></i>,
      title: 'Docs Management',
      link: '/company/PROWork',
      is_fav: isFav('/company/PROWork', 'Docs Management'),

      header: 'Admin Support',
    },
    {
      icon: (
        <i
          className="las la-chalkboard-teacher"
          style={{ fontSize: '1.2em' }}
        ></i>
      ),
      title: 'Training',
      link: '/company/Training',
      is_fav: isFav('/company/Training', 'Training'),

      header: 'Admin Support',
    },
    {
      icon: <i className="las la-file-alt" style={{ fontSize: '1.2em' }}></i>,
      title: 'Letter Generation',
      link: '/company/letter-generator',
      is_fav: isFav('/company/letter-generator', 'Letter Generation'),

      header: 'Admin Support',
    },
    {
      icon: <i className="las la-signature" style={{ fontSize: '1.2em' }}></i>,
      title: 'Digital Signature Docs',
      link: '/company/digital-signature-docs',
      is_fav: isFav(
        '/company/digital-signature-docs',
        'Digital Signature Docs',
      ),

      header: 'Admin Support',
    },
    {
      icon: null,
      title: 'Payroll',
      link: null,
    },
    {
      icon: <i className="las la-chart-bar" style={{ fontSize: '1.2em' }}></i>,
      title: 'Dashboard',
      link: '/company/Payrolldashboard',
      is_fav: isFav('/company/Payrolldashboard', 'Dashboard'),

      header: 'Payroll',
    },
    {
      icon: (
        <i
          className="las la-hand-holding-usd"
          style={{ fontSize: '1.2em' }}
        ></i>
      ),
      title: 'Payroll Settlement',
      link: '/company/PayrollSettlement',
      is_fav: isFav('/company/PayrollSettlement', 'Payroll Settlement'),

      header: 'Payroll',
    },
    {
      icon: <i className="las la-tools" style={{ fontSize: '1.2em' }}></i>,
      title: 'Payroll Setup',
      link: '/company/PayrollSetup',
      is_fav: isFav('/company/PayrollSetup', 'Payroll Setup'),

      header: 'Payroll',
    },
    {
      icon: (
        <i className="las la-user-shield" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Payroll Admin',
      link: '/company/PayrollAdmin',
      is_fav: isFav('/company/PayrollAdmin', 'Payroll Admin'),

      header: 'Payroll',
    },
    {
      icon: (
        <i
          className="las la-file-invoice-dollar"
          style={{ fontSize: '1.2em' }}
        ></i>
      ),
      title: 'FnF',
      link: '/company/FnF',
      is_fav: isFav('/company/FnF', 'FnF'),

      header: 'Payroll',
    },
    {
      icon: null,
      title: 'Reports',
      link: null,
    },
    {
      icon: <i className="las la-chart-area" style={{ fontSize: '1.2em' }}></i>,
      title: 'Attendance Report',
      link: '/company/AttendanceReport',
      is_fav: isFav('/company/AttendanceReport', 'Attendance Report'),

      header: 'Reports',
    },
    {
      icon: <i className="las la-chart-bar" style={{ fontSize: '1.2em' }}></i>,
      title: 'Payroll Report',
      link: '/company/PayrollReport',
      is_fav: isFav('/company/PayrollReport', 'Payroll Report'),

      header: 'Reports',
    },
    {
      icon: (
        <i className="las la-clipboard-list" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Leave Report',
      link: '/company/LeaveReport',
      is_fav: isFav('/company/LeaveReport', 'Leave Report'),

      header: 'Reports',
    },

    {
      icon: <i className="las la-chart-area" style={{ fontSize: '1.2em' }}></i>,
      title: 'Accrual Report',
      link: '/company/AccrualReport',
      is_fav: isFav('/company/AccrualReport', 'Accrual Report'),

      header: 'Reports',
    },
    {
      icon: <i className="las la-chart-area" style={{ fontSize: '1.2em' }}></i>,
      title: 'Localization Report',
      link: '/company/LocalizationReport',
      is_fav: isFav('/company/LocalizationReport', 'Localization Report'),

      header: 'Reports',
    },
    {
      icon: <i className="las la-file-alt" style={{ fontSize: '1.2em' }}></i>,
      title: 'Document Report',
      link: '/company/DocumentReport',
      is_fav: isFav('/company/DocumentReport', 'Document Report'),
      header: 'Reports',
    },
    
    {
      icon: <i className="las la-calendar-check" style={{ fontSize: '1.2em' }}></i>,
      title: 'Offboarding Report',
      link: '/company/OffboardingReport',
      is_fav: isFav('/company/OffboardingReport', 'Offboarding Report'),
      header: 'Reports',
    },
    {
      icon: <i className="las la-id-card" style={{ fontSize: '1.2em' }}></i>,
      title: 'Employee Data Report',
      link: '/company/EmployeeDataReport',
      is_fav: isFav('/company/EmployeeDataReport', 'Employee Data Report'),
      header: 'Reports',
    },

    {
      icon: <i className="las la-users-cog" style={{ fontSize: '1.2em' }}></i>,
      title: 'User Access Report',
      link: '/company/UserAccessReport',
      is_fav: isFav('/company/UserAccessReport', 'User Access Report'),

      header: 'Reports',
    },
    {
      icon: (
        <i className="las la-credit-card" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Payments Report',
      link: '/company/PaymentReport',
      is_fav: isFav('/company/PaymentReport', 'Payments Report'),

      header: 'Reports',
    },
    {
      icon: null,
      title: 'Meta Report',
      link: null,
    },
    {
      icon: <i className="las la-chart-area" style={{ fontSize: '1.2em' }}></i>,
      title: 'AI Report',
      link: '/company/AIReport',
      header: 'Meta Report',
    },
    {
      
      icon: null,
      title: 'HR Help Desk',
      link: null,
    },
    {
      
      icon: <i className="las la-comment-dots" style={{ fontSize: '1.2em' }}></i>,
      title: 'Task Queue',
      link: '/company/HRTicketDesk/TaskQueue',
      is_fav: isFav('/company/HRTicketDesk/TaskQueue', 'Task Queue'),

      header: 'HR Help Desk',
    },
    {
      
      icon: null,
      title: 'Handbook & SOP',
      link: null,
    },
    {
      icon: <i className="las la-book" style={{ fontSize: '1.2em' }}></i>,
      title: 'Handbook & SOP',
      link: '/company/HandbookSop',
      is_fav: isFav('/company/HandbookSop', 'Handbook & SOP'),
      header: 'Handbook & SOP',
    },
    {
      icon: null,
      title: 'Service Management',
      link: null,
    },
    {
      icon: (
        <i className="las la-clipboard-check" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Service Management',
      link: '/company/ServiceManagement',
      is_fav: isFav('/company/ServiceManagement', 'Service Management'),

      header: 'Service Management',
    },

    {
      icon: null,
      title: 'Support',
      link: null,
    },
    {
      icon: <i className="las la-headset" style={{ fontSize: '1.2em' }}></i>,
      title: 'Support',
      link: '/company/Support',
      is_fav: isFav('/company/Support', 'Support'),

      header: 'Support',
    },
    {
      icon: null,
      title: 'CB-Support',
      link: null,
    },
    {
      icon: <i className="las la-users-cog" style={{ fontSize: '1.2em' }}></i>,
      title: 'CB-Support',
      link: '/company/CBSupport',
      is_fav: isFav('/company/CBSupport', 'CB-Support'),

      header: 'CB-Support',
    },
    {
      icon: <i className="las la-user-times" style={{ fontSize: '1.2em' }}></i>,
      title: 'CB-UnAssigned',
      link: '/company/CBSupport/CBUnAssigned',
      is_fav: isFav('/company/CBSupport/UnAssigned', 'UnAssigned'),

      header: 'CB-Support',
    },
    {
      icon: <i className="las la-user-check" style={{ fontSize: '1.2em' }}></i>,
      title: 'CB-AssignedToMe',
      link: '/company/CBSupport/CBAssignedToMe',
      is_fav: isFav('/company/CBSupport/AssignedToMe', 'AssignedToMe'),

      header: 'CB-Support',
    },
    {
      icon: null,
      title: 'Super Admin',
      link: null,
    },
    {
      icon: <i className="las la-city" style={{ fontSize: '1.2em' }}></i>,
      title: 'Company',
      link: '/company/company-setup',
      is_fav: isFav('/company/company-setup', 'Company'),

      header: 'Super Admin',
    },
    {
      icon: (
        <i className="las la-project-diagram" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Org Structure',
      link: '/company/organisation-structure',
      is_fav: isFav('/company/organisation-structure', 'Org Structure'),

      header: 'Super Admin',
    },
    {
      icon: (
        <i className="las la-network-wired" style={{ fontSize: '1.2em' }}></i>
      ),
      title: 'Workflow',
      link: '/company/workflows',
      is_fav: isFav('/company/workflows', 'Workflow'),

      header: 'Super Admin',
    },
    // {
    //   icon: <i className="las la-wallet" style={{ fontSize: '1.2em' }}></i>,
    //   title: 'Billing & Credits',
    //   link: '/company/BillingAndCredits',
    //   is_fav: isFav('/company/BillingAndCredits', 'Billing & Credits'),
    //
    //   header: 'Super Admin',
    // },
    {
      icon: <i className="las la-file-alt" style={{ fontSize: '1.2em' }}></i>,
      title: 'Reports',
      link: '/company/report',
    },
    {
      icon: null,
      title: 'Others',
      link: null,
    },
    {
      icon: <i className="lab la-orcid" style={{ fontSize: '1.2em' }}></i>,
      title: 'Reference Id',
      link: '/company/ReferencesId',
      is_fav: isFav('/company/ReferencesId', 'Reference Id'),
      header: 'Others',
    },
    {
      icon: null,
      title: 'Performance',
      link: null,
    },
    /* {
      icon: <i className="las la-chart-area" style={{ fontSize: '1.2em' }}></i>,
      title: 'Emp. Performance',
      link: '/company/EmployeePerfomance',
      header: 'Performance',
    }, */
    {
      icon: <i className="las la-chart-area" style={{ fontSize: '1.2em' }}></i>,
      title: 'Configuration',
      link: '/company/PerfomanceConfiguration',
      header: 'Performance',
    },
  ];

  return mainmenu;
};

export const StatusRole = [
  {
    id: 'Open',
    label: 'Open',
  },
  {
    id: 'Start',
    label: 'Start',
  },
  {
    id: 'Pause',
    label: 'Pause',
  },
  {
    id: 'End',
    label: 'End',
  },
  {
    id: 'Close',
    label: 'Close',
  },
  {
    id: 'Others',
    label: 'Others',
  },
];

export const formatDuration = (seconds) => {
  if (seconds < 60) return seconds + 's';

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  if (minutes < 60) return minutes + 'm' + (secs > 0 ? ' ' + secs + 's' : '');

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  if (hours < 24)
    return (
      hours +
      'h' +
      (mins > 0 ? ' ' + mins + 'm' : '') +
      (secs > 0 ? ' ' + secs + 's' : '')
    );

  const days = Math.floor(hours / 24);
  const hr = hours % 24;

  return (
    days +
    'd' +
    (hr > 0 ? ' ' + hr + 'h' : '') +
    (mins > 0 ? ' ' + mins + 'm' : '') +
    (secs > 0 ? ' ' + secs + 's' : '')
  );
};

export const timeToMinutes = (timeStr) => {
  if (!timeStr) return null;

  const parts = timeStr.split(':');
  if (parts.length < 2) return null;

  const hours = Number(parts[0] || 0);
  const minutes = Number(parts[1] || 0);

  return hours * 60 + minutes;
};

export const formatMinutesToTime = (totalMinutes) => {
  if (
    totalMinutes === null ||
    totalMinutes === undefined ||
    Number.isNaN(totalMinutes)
  ) {
    return '';
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.round(totalMinutes % 60);

  const paddedHours = String(hours).padStart(2, '0');
  const paddedMinutes = String(minutes).padStart(2, '0');

  return `${paddedHours}:${paddedMinutes}`;
};
